import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { ModalContext, GlobalContext } from '../../components/contexts';
import GbitTablePaging from '../../components/tableComponents/GbitTablePaging';
import { dbPost } from '../../apis/commonApi';
import { NumericFormat } from 'react-number-format';

import { useNavigate, useLocation } from 'react-router-dom';
import ValidateService from '../../services/ValidateService';

import SelectEnt from '../../components/selectComponents/SelectEnt';

const WrkrList = () => {
  useEffect(() => {
    document.title = '근로자 관리';
  }, []);

  const location = useLocation();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const { store, updateStore } = useContext(GlobalContext);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    entSn: '',
    entId: '',
    userType: '',
  });

  const [wrkrList, setWrkrList] = useState([]);
  const [wrkrShowList, setWrkrShowList] = useState([]);
  const [showOpt, setShowOpt] = useState({
    useYnY: true,
    useYnN: true,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);

  const onFormDataChange = (model, value) => {
    setFormData(prev => ({ ...prev, [model]: value }));
  };

  const paginatedData = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    return wrkrShowList.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = page => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entSn: store.entSn || '',
        entId: store.userId || '',
        userType: store.userType || '',
      }));
    }
  }, [store]);

  useEffect(() => {
    if (formData.entId !== '') {
      const url = '/member/getUserInfo.do';
      const param = {
        userId: formData.entId.replace(/\s+/g, ''),
        userType: formData.userType,
      };
      dbPost(url, param)
        .then(response => {
          setFormData(prevFormData => ({
            ...prevFormData,
            entSn: response.entSn || '',
            entNm: response.entNm || '',
          }));
        })
        .catch(error => {});
    }
  }, [formData.entId]);

  useEffect(() => {
    if (formData.entSn != '') {
      getWrkrList();
    }
  }, [formData.entSn]);

  const getWrkrList = async () => {
    const url = '/aia/getWrkrList.do';
    const param = {
      entSn: formData.entSn,
    };
    dbPost(url, param)
      .then(response => {
        setWrkrList(Array.isArray(response) ? response : []);
        setWrkrShowList(Array.isArray(response) ? response : []);
        setCheckedItems([]);
      })
      .catch(error => {
        setWrkrShowList([]);
        setWrkrList([]);
        setCheckedItems([]);
      });
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 500);
    });
  };

  const deleteWrkr = async () => {
    const url = '/aia/deleteWrkr.do';
    const param = checkedItems.map(item => ({
      ...item,
      entSn: formData.entSn,
    }));
    try {
      const response = await dbPost(url, param);
      await getWrkrList();
      await modalService.successAlert('변경사항을 적용했습니다.');
    } catch (error) {}
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        entSn: formData.entSn,
        wrkrNm: '',
        wrkrRole: '',
        wrkrMblTelno: '',
        wrkrDept: '',
      },
    ]);
  };

  const handleDeleteRow = index => {
    setRows(prevRows => {
      const newRows = [...prevRows];
      newRows.splice(index, 1);
      return newRows;
    });
  };

  const handleInputChange = (index, id, e) => {
    const { value } = e.target;
    setRows(prevRows => {
      const newRows = [...prevRows];
      newRows[index][id] = value;
      return newRows;
    });
  };

  const handleAllCheck = e => {
    const isChecked = e.target.checked;
    if (isChecked) {
      const allItems = wrkrList.map(item => ({
        wrkrSn: item.wrkrSn,
        useYn: item.useYn,
      }));
      setCheckedItems(allItems);
    } else {
      setCheckedItems([]);
    }
  };

  const handleCheckboxChange = (wrkrSn, useYn) => {
    setCheckedItems(prevCheckedItems => {
      const itemIndex = prevCheckedItems.findIndex(
        item => item.wrkrSn === wrkrSn
      );
      if (itemIndex !== -1) {
        // 항목이 이미 존재하는 경우, useYn 값을 업데이트
        const updatedItems = [...prevCheckedItems];
        updatedItems[itemIndex].useYn = useYn;
        return updatedItems.filter(item => item.wrkrSn !== wrkrSn);
      } else {
        // 항목이 존재하지 않는 경우, 새 항목 추가
        return [...prevCheckedItems, { wrkrSn, useYn }];
      }
    });
  };

  useEffect(() => {
    let filteredList = [];

    if (showOpt.useYnY && !showOpt.useYnN) {
      filteredList = wrkrList.filter(item => item.useYn === 'Y');
    } else if (!showOpt.useYnY && showOpt.useYnN) {
      filteredList = wrkrList.filter(item => item.useYn === 'N');
    } else if (showOpt.useYnY && showOpt.useYnN) {
      filteredList = wrkrList.filter(
        item => item.useYn === 'Y' || item.useYn === 'N'
      );
    } else {
      filteredList = [];
    }

    setWrkrShowList(filteredList);
  }, [showOpt, wrkrList]);

  const handleCheckboxChangeA = e => {
    const { name, checked } = e.target;
    setShowOpt(prevShowOpt => ({
      ...prevShowOpt,
      [name]: checked,
    }));
  };
  const insertWrkrList = async () => {
    const url = '/aia/insertWrkrList.do';

    const param = rows;
    for (let i = 0; i < param.length; i++) {
      if (
        param[i].wrkrNm === '' ||
        param[i].wrkrRole === '' ||
        param[i].wrkrMblTelno === '' ||
        param[i].wrkrDept === ''
      ) {
        await modalService.errorAlert('빈칸을 채워주세요.');
        return;
      } else {
        try {
          const response = await dbPost(url, param);
          setRows([]);
          await getWrkrList();

          await modalService.successAlert('변경사항을 저장했습니다.');
        } catch (error) {}
      }
    }
  };

  const activation = async (paramOne, paramTwo) => {
    const url = '/aia/wrkrActivate.do';
    const postParam = {
      entSn: formData.entSn,
      wrkrSn: paramOne,
      useYn: paramTwo,
    };
    try {
      const response = await dbPost(url, postParam);
      await getWrkrList();
      if (paramTwo === 'Y') {
        await modalService.successAlert('근로자를 비활성화했습니다.');
      } else if (paramTwo === 'N') {
        await modalService.successAlert('근로자를 활성화했습니다.');
      }
    } catch (error) {}
  };

  const formatPhoneNumber = phoneNumber => {
    if (phoneNumber.length === 11) {
      return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return phoneNumber;
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">근로자 관리</h2>
      </div>
      <ul className="guide-txt">
        <li>기업에 등록된 근로자 관리 페이지입니다.</li>
      </ul>
      <div className="tbl-wrap">
        <p className="tbl-msg">
          <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
        </p>
        <table className="tbl data row">
          <colgroup>
            <col style={{ width: '15%' }} />
            <col style={{ width: '35%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '35%' }} />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">기업명</th>
              <td>
                <div className="input-group">
                  {store.authrtId === 'ADMIN' ? (
                    <SelectEnt
                      model="entSn"
                      valueObj={formData}
                      valueChange={(model, value) => {
                        onFormDataChange(model, value);
                      }}
                    />
                  ) : (
                    <p>{formData.entNm || ''}</p>
                  )}
                </div>
              </td>
              <th scope="row">사용여부</th>
              <td>
                <div
                  className="form-check"
                  style={{ display: 'inline-block', marginRight: '10px' }}
                >
                  <input
                    type="checkbox"
                    id="chkBoxA"
                    name="useYnY"
                    checked={showOpt.useYnY === true}
                    onChange={handleCheckboxChangeA}
                  />
                  <label htmlFor="chkBoxA">사용</label>
                </div>
                <div
                  className="form-check"
                  style={{ display: 'inline-block', marginRight: '10px' }}
                >
                  <input
                    type="checkbox"
                    id="chkBoxB"
                    name="useYnN"
                    checked={showOpt.useYnN === true}
                    onChange={handleCheckboxChangeA}
                  />
                  <label htmlFor="chkBoxB">미사용</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="tbl-wrap">
        <h3 className="block-tit">근로자 목록</h3>
        <table className="tbl col data scroll">
          <thead>
            <tr>
              <th scope="col">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name="chk_all"
                    id="chk_all"
                    onChange={handleAllCheck}
                    checked={checkedItems.length === wrkrList.length}
                  />
                  <label htmlFor="chk_all">
                    <span className="sr-only">전체선택</span>
                  </label>
                </div>
              </th>
              <th scope="col">성명</th>
              <th scope="col">직책</th>
              <th scope="col">휴대전화</th>
              <th scope="col">부서</th>
              <th scope="col">사용여부</th>
            </tr>
          </thead>
          <tbody>
            {/* list start */}
            {paginatedData().map((wrkrShowList, index) => (
              <tr key={index}>
                <td>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      checked={checkedItems.some(
                        item => item.wrkrSn === wrkrShowList.wrkrSn
                      )}
                      name={wrkrShowList.wrkrSn}
                      id={wrkrShowList.wrkrSn}
                      onChange={() =>
                        handleCheckboxChange(
                          wrkrShowList.wrkrSn,
                          wrkrShowList.useYn
                        )
                      }
                    />
                    <label htmlFor={wrkrShowList.wrkrSn}>
                      <span className="sr-only">선택</span>
                    </label>
                  </div>
                </td>
                <td>
                  <strong>{wrkrShowList.wrkrNm}</strong>
                </td>
                <td>{wrkrShowList.wrkrRole}</td>
                <td>{formatPhoneNumber(wrkrShowList.wrkrMblTelno)}</td>
                <td>{wrkrShowList.wrkrDept}</td>
                <td>
                  {wrkrShowList.useYn === 'Y' ? (
                    <span
                      className="krds-badge bg1"
                      onClick={() => {
                        activation(wrkrShowList.wrkrSn, wrkrShowList.useYn);
                      }}
                    >
                      사용
                    </span>
                  ) : (
                    <span
                      className="krds-badge bg2"
                      onClick={() => {
                        activation(wrkrShowList.wrkrSn, wrkrShowList.useYn);
                      }}
                    >
                      미사용
                    </span>
                  )}
                </td>
              </tr>
            ))}
            {rows.map((row, index) => (
              <tr key={index} id={`tr-${index}`}>
                <td></td>
                <td>
                  <label className="hidden-label" htmlFor={`wrkrNm-${index}`}>
                    라벨
                  </label>
                  <input
                    type="text"
                    id={`wrkrNm-${index}`}
                    value={row.wrkrNm}
                    name="근로자 성명"
                    onChange={e => handleInputChange(index, 'wrkrNm', e)}
                    placeholder="성명"
                    className="form-control"
                    maxLength={20}
                    aria-labelledby={`wrkrNm-${index}`}
                  />
                </td>
                <td>
                  {' '}
                  <label className="hidden-label" htmlFor={`wrkrRole-${index}`}>
                    라벨
                  </label>
                  <input
                    type="text"
                    id={`wrkrRole-${index}`}
                    name="근로자 직책"
                    value={row.wrkrRole}
                    onChange={e => handleInputChange(index, 'wrkrRole', e)}
                    placeholder="직책"
                    className="form-control"
                    maxLength={6}
                    aria-labelledby={`wrkrRole-${index}`}
                  />
                </td>
                <td>
                  {' '}
                  {/* <input
                    type="text"
                    id={`wrkrMblTelno-${index}`}
                    name="근로자 휴대전화"
                    value={row.wrkrMblTelno}
                    onChange={e => handleInputChange(index, 'wrkrMblTelno', e)}
                    placeholder="휴대전화"
                    className="form-control"
                  /> */}
                  <NumericFormat
                    type="text"
                    id={`wrkrMblTelno-${index}`}
                    className="form-control"
                    value={row.wrkrMblTelno}
                    onChange={e => handleInputChange(index, 'wrkrMblTelno', e)}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    placeholder="휴대전화"
                    allowLeadingZeros={true}
                    aria-labelledby={`wrkrMblTelno-${index}`}
                  />
                  <label
                    className="hidden-label"
                    htmlFor={`wrkrTelno-${index}`}
                  >
                    라벨
                  </label>
                </td>
                <td>
                  {' '}
                  <input
                    type="text"
                    id={`wrkrDept-${index}`}
                    name="근로자 부서"
                    value={row.wrkrDept}
                    onChange={e => handleInputChange(index, 'wrkrDept', e)}
                    placeholder="부서"
                    className="form-control"
                    maxLength={6}
                    aria-labelledby={`wrkrDept-${index}`}
                  />
                  <label className="hidden-label" htmlFor={`wrkrDept-${index}`}>
                    라벨
                  </label>
                </td>
                <td>
                  <button
                    type="button"
                    className="btn xlg tertiary open-modal"
                    onClick={() => handleDeleteRow(index)}
                  >
                    행 삭제
                  </button>
                </td>
              </tr>
            ))}
            {/* list end */}
          </tbody>
        </table>
      </div>
      <GbitTablePaging
        totalItems={wrkrList.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
      <div className="page-btn-wrap both">
        <div className="btn-wrap">
          <button
            type="button"
            className="btn xlg tertiary"
            onClick={handleAddRow}
          >
            행 추가
          </button>
        </div>{' '}
        <div className="btn-wrap">
          <button
            type="button"
            className="btn xlg primary"
            onClick={deleteWrkr}
          >
            활성화 변경
          </button>
          <button
            type="button"
            className="btn xlg primary"
            onClick={insertWrkrList}
          >
            변경사항 저장
          </button>
        </div>
      </div>
    </>
  );
};

export default WrkrList;
